import styled from 'styled-components'

export const DropZonesContainer = styled.div`
  display: flex;
  flex: 1;
  height: 100%;
`
